<template>
    <div>
        <breadCrumb 
            :icon="'fa-box-alt'"
            :category="$t(`sideNav.navSalonMenu`)"
            :subCategory="$t(`subMenu.salon_menu_package`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-if="!addPackageToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New Package" @click="addPackageToggle = !addPackageToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add') + $t(`subMenu.salon_menu_package`)}}</span>
            </button>
        </div>
        <div v-if="addPackageToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('button_link.add') + $t(`subMenu.salon_menu_package`)}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content p-5">
                        <ul class="nav nav-pills nav-justified" role="tablist">
                            <li v-for="progress in this.$i18n.messages[this.$i18n.locale].tab.packageProgressTab" :key="progress.id" class="nav-item">
                                <a :class="{'active': selectedTab == progress.id}" class="nav-link border-bottom-left-radius-0 border-bottom-right-radius-0" data-toggle="tab">{{progress.id}}. {{progress.text}}</a>
                            </li>
                        </ul>
                        <div class="tab-content mt-5">
                            <packageInfo class="tab-pane" :class="{'active': selectedTab == 1}" :category="categoryLists" :isEdit="false" @returnPackageList="closeModal" @submitPackageInfo="addPackageNext"></packageInfo>     
                            <packageItems class="tab-pane" :class="{'active': selectedTab == 2}" @submitPackageItem="addPackageNext" @returnPreviousStep="addPackagePrev" @returnPackageList="closeModal" ></packageItems>     
                            <packagePrice v-if="selectedTab == 3" class="tab-pane active" :package="addPackageItems" :isEdit="editToggleModal" @returnPreviousStep="addPackagePrev" @returnPackageList="closeModal" @submitPackage="submitAddPackage"></packagePrice>     
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!addPackageToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-12 col-md-12 align-items-center justify-content-start mb">
                            <div class="dataTables_filter mb-2">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchPackage" @keypress.enter="searchPackageItem">
                                    <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0" @click="searchPackageItem">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="showEnabled" @change="filterEnable($event)" v-model="isEnable">
                                <label class="custom-control-label" for="showEnabled">{{$t('label.show_enable')}}</label>
                            </div>
                        </div>
                    </div>
                    <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" v-for="c in categoryLists" :key="c.id">
                                <a :class="{'active': selectedCategory == c.id}" class="nav-link" role="tab" @click="filterCategory(c.id)">{{c.text}}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="packageItems" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(title)="data">
                                            <a class="text-primary fw-500 link" @click="showEditPackage(data.item.itemID)">{{data.item.title}}</a>
                                        </template>
                                        <template #cell(price)="data">
                                            {{formatPrice(data.item.price)}}
                                        </template>
                                        <template #cell(basePrice)="data">
                                            {{formatPrice(data.item.basePrice)}}
                                        </template>
                                        <template #cell(category)="data">
                                            {{getCategoryText(data.item.category)}}
                                        </template>
                                        <template #cell(isEnable)="data">
                                            <span class="badge" :class="data.item.isEnable == 1 ? 'badge-primary' : 'badge-secondary'">{{data.item.isEnable == 1 ? $t('table.value.enable') : $t('table.value.disable')}}</span>
                                        </template>
                                        <template #cell(policy)="data">
                                            <a class="link d-block text-primary" :title="$t('button_link.view_update', {'item': $t('table.header.policy')})" @click="viewPolicy(data.item.itemID, data.item.title)">
                                                <div class='icon-stack fs-xl'>
                                                    <i class="fal fa-shield-check icon-stack-3x opacity-100 color-primary-500"></i><i class="fal fa-cog icon-stack-2x opacity-100 color-primary-300 ml-3" style="top: .5em;"></i>
                                                </div>
                                            </a>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': policyToggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit_policy', {'item': $t(`subMenu.salon_menu_package`)})}}
                            <small class="m-0 text-muted">{{$t('subMenu.salon_menu_package')}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="policyToggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body edit-modal-body">
                        <form @submit.prevent="submitPolicy">
                            <template>
                                <vue-editor v-model="content" />
                            </template>
                            <div class="text-left border-top pt-3 mt-3 mb-3">
                                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': editToggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit') + $t(`subMenu.salon_menu_package`)}}
                            <small class="m-0 text-muted">{{$t(`subMenu.salon_menu_package`)}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="closeModal(false)">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body edit-modal-body">
                        <ul class="nav nav-pills nav-justified" role="tablist">
                            <li v-for="progress in this.$i18n.messages[this.$i18n.locale].tab.packageProgressTab" :key="progress.id" class="nav-item">
                                <a :class="{'active': selectedTab == progress.id}" class="nav-link border-bottom-left-radius-0 border-bottom-right-radius-0" data-toggle="tab">{{progress.id}}. {{progress.text}}</a>
                            </li>
                        </ul>
                        <div class="tab-content mt-5">
                            <packageInfo ref="editPackageInfo" :class="{'active': selectedTab == 1}" class="tab-pane" :category="categoryLists" :isEdit="true" @returnPackageList="closeModal" @submitPackageInfo="addPackageNext" @disablePackage="submitEditPackage"></packageInfo>     
                            <packageItems ref="editPackageItems" :class="{'active': selectedTab == 2}" class="tab-pane" :isEdit="true" @submitPackageItem="addPackageNext" @returnPreviousStep="addPackagePrev" @returnPackageList="closeModal" @disablePackage="submitEditPackage"></packageItems>     
                            <packagePrice  class="tab-pane active" :package="editPackageItems" :isEdit="editToggleModal" v-if="selectedTab == 3" @returnPreviousStep="addPackagePrev" @returnPackageList="closeModal" @submitPackage="submitEditPackage"></packagePrice>     
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <div id="loadingModal" :class="{'show': loadingModalToggle}" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="loading-modal-content border-0 ">
                    <div class="modal-body text-center">
                        <div class="spinner-border text-light" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="text-light mt-2">{{$t('message.data.fetching_wait')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import { VueEditor } from "vue2-editor";
import PackageInfo from './Package_Add_Info'
import PackageItems from './Package_Add_Items'
import PackagePrice from './Package_Add_Price'

import moment from 'moment'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
import {setReturnData, handleSessionExpired, getCategoryText, setCategoryLabel}
from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'menuPackage',
    components:{
        PackageInfo, PackageItems, PackagePrice,
        VueEditor, BreadCrumb
    },
    data(){
        return{
            type: "package",
            categoryLists: [], selectedCategory: "all",
            searchPackage: "", isEnable: true,
            content: "",
            selectedTab: 1, editSelectedTab: 1,
            packageItems: [],  packageDetails: [],
            addPackageItems: {}, editPackageItems:{},
            addPackageToggle: false, editToggleModal: false, deleteToggleModal: false, loadingModalToggle: false, policyToggleModal: false,
            isSpinnerShow: false, 
            sTitle: "", itemID: 0,
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "", packageExportData: []

        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "price", label: this.$i18n.t('table.header.price'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "basePrice", label: this.$i18n.t('table.header.base_price'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "category", label: this.$i18n.t('table.header.category'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "isEnable", label: this.$i18n.t('table.header.enable'), thClass: 'thead-themed align-middle'},
                { key: "policy", label: this.$i18n.t('table.header.policy'), thClass: 'thead-themed align-middle'}
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.title')).toUpperCase()] = "title"
            ret[(this.$i18n.t('table.header.price')).toUpperCase()] = "price"
            ret[(this.$i18n.t('table.header.base_price')).toUpperCase()] = "basePrice"
            ret[(this.$i18n.t('table.header.category')).toUpperCase()] = "category"
            ret[(this.$i18n.t('table.header.enable')).toUpperCase()] = "isEnable"
            return ret
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setCategory()
            this.setExportData(this.packageExportData)
        }
    },
    methods:{
        getImage(img){
            return img
        },
        formatPrice(price){
            return formatPrice(price);
        },
        getCategoryText(id){
            return getCategoryText(id, this.categoryLists)
        },
        closeModal(isError){
            if(!isError){
                this.addPackageToggle = this.editToggleModal = false;
                this.selectedTab = 1;
                this.addPackageItems = {};
                this.clearFilter()
            }
            this.$parent.isModalShow = false;
        },
        clearFilter(){
            this.isEnable = true;
            this.searchPackage = "";
            this.filterCategory("all");
        },
        searchPackageItem(){
            var strFilter = "&search=" + this.searchPackage;
            this.getPackageItem(strFilter);

            this.selectedCategory = "all";
            this.isEnable = true;
        },
        filterCategory(item){
            this.page = 0;
            this.selectedCategory = item;
            this.filterPackageItem(this.selectedCategory, this.isEnable);
        },
        filterEnable(e){
            this.isEnable = e.target.checked ? true : false;
            this.filterPackageItem(this.selectedCategory, this.isEnable);
        },
        filterPackageItem(catID, isEnable){
            var strCatFilter = catID == "all" ? "" : "&category=" + catID;
            var strFilterIsEnable = isEnable ? "&isEnable=1" : "&isEnable=0";
            var strFilter = strCatFilter + strFilterIsEnable;
            this.getPackageItem(strFilter);
        },
        async getExportData(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=" + this.type + strFilter
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.items
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.packageExportData = result
            this.setExportData(result)
        },
        setExportData(data){
            this.exportData = []
            let header = this.$msg.REPORT.HEADER + this.$i18n.t('sideNav.navSalonMenu') + " - " + this.$i18n.t('subMenu.salon_menu_package')
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];

            this.exportFileName = header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    title: data[i].title,
                    price: data[i].price,
                    basePrice: data[i].basePrice,
                    category: getCategoryText(data[i].category, this.categoryLists),
                    isEnable: data[i].isEnable == 1 ? this.$i18n.t('table.value.enable') : this.$i18n.t('table.value.disable')
                })
            }
        },
        async getPackageItem(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=" + this.type + "&page=" + this.page + strFilter
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            this.isSpinnerShow = true
            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var retData = setReturnData(response.data.items, response.data.count, $vm.page)
                $vm.packageItems = retData.result;
                $vm.totalEntries = retData.count;
                $vm.totalPage = retData.totalPage;

                $vm.startPage = retData.startPage;
                $vm.endPage = retData.endPage;
                $vm.isSpinnerShow = false;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            await this.getExportData(strFilter)
        },
        addPackageNext(step, data){ 
            this.selectedTab = step + 1;

            if(this.editToggleModal){
                this.editPackageItems = Object.assign(this.editPackageItems, data);
                if(this.selectedTab == 2) {
                    this.$refs.editPackageItems.editPackageItems(this.editPackageItems);
                } 
            }else{
                this.addPackageItems = Object.assign(this.addPackageItems, data);
            }
        },
        addPackagePrev(step){
            this.selectedTab = step - 1;
            if ('package' in this.addPackageItems){
                delete this.addPackageItems.package;
            }
        },
        submitAddPackage(item){
            let $vm = this
            this.addPackageItems = Object.assign(this.addPackageItems, item);
            this.addPackageItems["type"] = this.type;
            this.addPackageItems["folderID"] = "";
            this.addPackageItems["showOnline"] = "1";

            var data = this.addPackageItems;
            this.$axios({
                method: 'post', 
                url: this.$api.MENU_ITEM,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data;
                    var message = "'" + retData.title + "'" + $vm.$i18n.t('message.success.add')
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        async showEditPackage(id){
            let $vm = this;

            let QUERY_STRING = "/" + id + this.$api.PACKAGE_DETAIL
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            this.loadingModalToggle = true;
            var packageDetails = [];
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then((response) => {
                if(response.status == 200){
                    packageDetails = response.data;
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
                        
            var type = ["service", "product"]
            var disabledArr = []
            for(var i=0; i<type.length; i++){
                var result = await this.getDisableItems(type[i]);
                disabledArr.push(...result)
            }

            for(var j=0; j<disabledArr.length; j++){
                var detailsItems = packageDetails.package.items
                for(var k=0; k<detailsItems.length; k++){
                    if(detailsItems[k].itemID == disabledArr[j].itemID){
                        detailsItems[k].isEnable = 0
                    }
                }
            }

            this.loadingModalToggle = false;
            this.editToggleModal = true;
            this.sTitle = packageDetails.title
            this.$refs.editPackageInfo.editPackageInfo(packageDetails, this.categoryLists);

            // if(disabledItems.length == 0){
            //     this.editToggleModal = true;
            //     this.sTitle = packageDetails.title
            //     this.$refs.editPackageInfo.editPackageInfo(packageDetails, this.categoryLists);
            // }else{
            //     var message = "Error loading package details. ";
            //     for(var l=0; l<disabledItems.length; l++){
            //         message += disabledItems[l].title + (disabledItems.length - l == 1 ? "" : ", ")
            //     }
            //     message += " is disabled."
            //     this.$parent.setModal(this, true, true, message);
            // }

        },
        async getDisableItems(type){
            let $vm = this;
            let QUERY_STRING =  "?type=" + type + "&isEnable=0"
            const url =  this.$api.MENU_ITEM + QUERY_STRING;
            
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                if(response.status == 200){
                    result = response.data.items;

                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result;
        },
        submitEditPackage(item){
            let $vm = this
            this.editPackageItems = Object.assign(this.editPackageItems, item);
            let QUERY_STRING = "/" + this.editPackageItems.itemID + this.$api.UPDATE
            const url =  this.$api.MENU_ITEM + QUERY_STRING;
   
            var data = this.editPackageItems;
            this.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data;
                    var message = retData.isEnable == 1 ?  "'" + retData.title + "'" + $vm.$i18n.t('message.success.update') : "'" + retData.title + "'" + $vm.$i18n.t('message.success.disable')
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
            
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterPackageItem(this.selectedCategory, this.isEnable);
            }
        },
        async viewPolicy(id, title){
            console.log(id, title)
            this.policyToggleModal = true
            this.itemID = id
            this.sTitle = title

            let $vm = this;
            let QUERY_STRING =  "/" + id + this.$api.ITEM_POLICY
            const url =  this.$api.MENU_ITEM + QUERY_STRING;
            
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result[0]
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.content = result.policy
        },
        setCategory(){
            var category = JSON.parse(this.$store.state.category);
            this.categoryLists = setCategoryLabel(this, true, this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')}), category.package)
        },
    },
    mounted(){
        let $vm = this;
        $vm.setCategory()
        $vm.getPackageItem("");
    }
}
</script>

<style scoped>
.export-button{
    margin-top: -4.15em;
    margin-left: 1em;
}

.link, .nav-link{
    cursor: pointer;
}

.link > i {
    font-size: large;
}

.show{
    display: block;
}

.edit-modal-body{
    max-height: 80vh;
    overflow-y: auto;
}
.loading-modal-content{
    background: transparent;
    box-shadow: none;
}

</style>